import React from 'react';

import { getBaseCohortsApi } from 'api/views';
import { useDispatch } from 'react-redux';
import {
  VIEWS_ACTIONS,
  setActiveTab,
  setShowViewsPanel,
  setViewAction,
  setViewWithSelectedView,
} from 'reducers/viewsSlice';
import styled from 'styled-components';

import { VIEWS_FILTER_KEYS_DISPLAY_NAMES } from 'constants/ProjectConstants';

import { Typography6, Typography17 } from 'uiToolkit/Typography';
import { Button } from 'uiToolkitV1/Button';
import { TagOutlinedList } from 'uiToolkitV1/TagOutlinedList';

const Container = styled.div`
  padding: 1.5rem;
`;

const AttributesSection = ({ employeeFilters }) => {
  const dispatch = useDispatch();
  // VIEWS_FILTER_KEYS_DISPLAY_NAMES
  const filterTagList = Object.entries(employeeFilters || {}).map(([attributeName, selectedAttributeValues]) => ({
    id: attributeName,
    title: `${VIEWS_FILTER_KEYS_DISPLAY_NAMES[attributeName]} (${selectedAttributeValues.length})`,
  }));

  const openAttributeSelection = (activeTabId) => {
    getBaseCohortsApi({ pageType: 'STATUS' }).then((res) => {
      const baseCohorts = res?.entity?.baseCohort || [];
      const id = baseCohorts?.[0]?.uuid || '-1';
      dispatch(setViewAction(VIEWS_ACTIONS.EDIT_CUSTOM_ACCESS));
      dispatch(setViewWithSelectedView({ uuid: id, query: employeeFilters }));
      dispatch(setActiveTab(activeTabId));

      dispatch(
        setShowViewsPanel({
          onSuccess: () => {},
        })
      );
    });
  };

  return (
    <Container>
      <Typography6 weight={400} bottomGutter={1.5}>
        Which employee(s) should these permission(s) effect?
      </Typography6>
      <Typography17 bottomGutter={3}>
        Select appropriate attributes across which this access would come into effect
      </Typography17>

      {filterTagList.length > 0 ? (
        <TagOutlinedList
          tagList={filterTagList}
          onClickHandler={(id) => {
            openAttributeSelection(id);
          }}
        />
      ) : (
        <Button
          onClick={() => {
            openAttributeSelection();
          }}
        >
          Select Attributes
        </Button>
      )}
    </Container>
  );
};

export default AttributesSection;
